import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';
import { addEventListener } from 'common/js/media_query_event_polyfill';
import clickOutside from './click-outside';

class MobileNavigator {
  constructor() {
    // Header
    this.header = document.querySelector('[data-header]');

    // Mobile nav
    this.hamburgerButton = document.querySelector('[data-mobile-hamburger]');
    this.mobileMenu = document.querySelector('[data-mobile-nav]');

    // Mobile search
    this.searchButton = document.querySelector('[data-search-button-mobile]');
    this.searchField = document.querySelector('[data-search-field-mobile]');

    // State
    this.menuOpen = false;
    this.searchOpen = false;

    // MQL
    this.mql = window.matchMedia('(min-width: 960px');

    // Init
    this.toggleMobileNav();
    this.toggleMobileSearch();
    this.addResetListener();

    // This bindings
    this.setMenuHeight = this.setMenuHeight.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.closeSearch = this.closeSearch.bind(this);

    this.menuRemoveOffClick = null;
    this.searchRemoveOffClick = null;
  }

  toggleMobileNav() {
    this.hamburgerButton.addEventListener('click', () => {
      if (this.menuOpen) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    });
  }

  openMenu() {
    this.menuOpen = true;
    disableBodyScroll(this.mobileMenu);
    // Toggle menu
    this.mobileMenu.classList.remove('d-none');
    this.header.classList.add('header--mobile-nav-active');
    this.hamburgerButton.querySelector('i').classList.remove('fa-bars');
    this.hamburgerButton.querySelector('i').classList.add('fa-times');
    // Close menu when clicking off
    this.menuRemoveOffClick = clickOutside(
      this.mobileMenu.querySelector('.nav-mobile'),
      this.closeMenu,
      this.hamburgerButton
    );
    // Resize menu height to take up remaining space
    this.setMenuHeight();
    window.addEventListener('resize', this.setMenuHeight);
  }

  closeMenu() {
    this.menuOpen = false;
    clearAllBodyScrollLocks();
    // Toggle menu
    this.mobileMenu.classList.add('d-none');
    this.header.classList.remove('header--mobile-nav-active');
    this.hamburgerButton.querySelector('i').classList.add('fa-bars');
    this.hamburgerButton.querySelector('i').classList.remove('fa-times');
    // Remove resize listener
    window.removeEventListener('resize', this.setMenuHeight);
    // Remove off-click listener
    if (this.menuRemoveOffClick) {
      this.menuRemoveOffClick();
    }
  }

  setMenuHeight() {
    const remainingHeight = window.innerHeight - this.header.offsetHeight;
    this.mobileMenu.style.height = `${remainingHeight}px`;
  }

  // ** Mobile search **/

  toggleMobileSearch() {
    if (this.searchButton) {
      this.searchButton.addEventListener('click', () => {
        if (this.searchOpen) {
          this.closeSearch();
        } else {
          this.openSearch();
        }
      });
    }
  }

  openSearch() {
    this.searchOpen = true;
    // Toggle search
    this.searchField.classList.remove('d-none');
    this.header.classList.add('header--mobile-search-active');
    this.searchButton.querySelector('i').classList.remove('fa-search');
    this.searchButton.querySelector('i').classList.add('fa-times');
    // Focus on search field
    this.searchField.querySelector('input').focus();
    // Close search when clicking off
    this.searchRemoveOffClick = clickOutside(
      this.searchField,
      this.closeSearch,
      this.searchButton
    );
  }

  closeSearch() {
    if (!this.searchField) {
      return;
    }

    this.searchOpen = false;
    // Toggle search
    this.searchField.classList.add('d-none');
    this.header.classList.remove('header--mobile-search-active');
    this.searchButton.querySelector('i').classList.add('fa-search');
    this.searchButton.querySelector('i').classList.remove('fa-times');
    // Remove off-click listener
    if (this.searchRemoveOffClick) {
      this.searchRemoveOffClick();
    }
  }

  // ** Reset header **/

  addResetListener() {
    addEventListener(this.mql, (e) => {
      if (e.matches) {
        this.menuOpen = false;
        this.searchOpen = false;
        this.closeMenu();
        this.closeSearch();
      }
    });
  }
}

// Initialise here
document.addEventListener('DOMContentLoaded', () => new MobileNavigator());
